import React from 'react';

const NODES = [
  { id: 'qc', label: 'In-Line QC', cx: 210, cy: 130, color: '#d5b036', labelX: 164, labelY: 106, labelW: 92 },
  { id: 'nano', label: 'Nano Dispersion', cx: 130, cy: 172, color: '#2d8c57', labelX: 2, labelY: 158, labelW: 100 },
  { id: 'ai', label: 'AI Color Match', cx: 300, cy: 182, color: '#496cb1', labelX: 296, labelY: 164, labelW: 110 },
  { id: 'uv', label: 'UV Analytics', cx: 148, cy: 322, color: '#d5b036', labelX: 40, labelY: 310, labelW: 88 },
  { id: 'rpet', label: 'rPET Ready', cx: 310, cy: 314, color: '#2d8c57', labelX: 316, labelY: 300, labelW: 90 },
];

const ROW_NODE_MAP = ['ai', 'nano', 'qc', 'rpet'];

export function nodeIdForRow(index) {
  return ROW_NODE_MAP[index] ?? 'qc';
}

export default function InnovationNetwork({ activeNode = null }) {
  const hub = { cx: 210, cy: 240 };

  return (
    <div className="inno-network">
      <div className="inno-network__glow" aria-hidden="true" />
      <svg className="inno-network__svg" viewBox="0 0 420 480" fill="none" aria-hidden="true">
        <defs>
          <radialGradient id="inno-hub-grad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#d5b036" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#d5b036" stopOpacity="0.1" />
          </radialGradient>
          <filter id="inno-glow">
            <feGaussianBlur stdDeviation="6" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <g className="inno-network__wireframe" opacity="0.12" stroke="#d5b036" strokeWidth="1">
          <line x1="60" y1="80" x2="140" y2="120" />
          <line x1="140" y1="120" x2="220" y2="80" />
          <line x1="60" y1="200" x2="140" y2="230" />
          <line x1="140" y1="230" x2="220" y2="200" />
          <line x1="60" y1="80" x2="60" y2="200" />
          <line x1="220" y1="80" x2="220" y2="200" />
        </g>

        {NODES.map((node) => (
          <line
            key={`link-${node.id}`}
            className={`inno-network__link${activeNode === node.id ? ' inno-network__link--active' : ''}`}
            x1={hub.cx}
            y1={hub.cy}
            x2={node.cx}
            y2={node.cy}
            stroke={node.color}
          />
        ))}

        <line x1="210" y1="240" x2="210" y2="130" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <line x1="210" y1="240" x2="210" y2="376" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />

        <circle className="inno-network__hub-outer" cx={hub.cx} cy={hub.cy} r="32" fill="url(#inno-hub-grad)" filter="url(#inno-glow)" />
        <circle className="inno-network__hub" cx={hub.cx} cy={hub.cy} r="14" fill="#d5b036" />
        <circle cx={hub.cx} cy={hub.cy} r="6" fill="#f2e6b8" />

        {NODES.map((node) => (
          <g
            key={node.id}
            className={`inno-network__node${activeNode === node.id ? ' inno-network__node--active' : ''}`}
          >
            <circle className="inno-network__node-glow" cx={node.cx} cy={node.cy} r="22" fill={node.color} opacity="0.25" />
            <circle className="inno-network__node-core" cx={node.cx} cy={node.cy} r="10" fill={node.color} />
            <rect
              className="inno-network__label-bg"
              x={node.labelX}
              y={node.labelY}
              width={node.labelW}
              height="22"
              rx="4"
              stroke={node.color}
            />
            <text
              className="inno-network__label"
              x={node.labelX + node.labelW / 2}
              y={node.labelY + 16}
              fill={node.color}
            >
              {node.label}
            </text>
          </g>
        ))}

        <circle className="inno-network__orb" r="4" fill="#f2e6b8">
          <animateMotion dur="12s" repeatCount="indefinite">
            <mpath href="#inno-orbit" />
          </animateMotion>
        </circle>
        <ellipse id="inno-orbit" cx="210" cy="240" rx="118" ry="76" fill="none" transform="rotate(-18 210 240)" />
      </svg>
    </div>
  );
}
